import { SkeletonLoader } from '@toggle/design-system';
import React from 'react';

import * as S from './DocumentLoader.styles';

export const DocumentLoader = () => (
  <S.SkeletonWrapper>
    <SkeletonLoader areas={S.SKELETON_AREAS} />
  </S.SkeletonWrapper>
);
